import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSSE } from '../app/providers/SseProvider';
import { SIGNAL_CREATED_SSE_EVENT } from '@terra/shared-contracts-signals';

export const useSignalCreatedSSE = ({
  applicationId,
  externalSurfaceId,
  listenForExternalNetworkSignals = false,
}: {
  applicationId?: string;
  externalSurfaceId?: string;
  listenForExternalNetworkSignals?: boolean;
}) => {
  const { subscribe } = useSSE();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!applicationId && !listenForExternalNetworkSignals) {
      return;
    }

    const unsubscribe = subscribe(SIGNAL_CREATED_SSE_EVENT, (event) => {
      if (event.targetType === 'EXTERNAL_NETWORK') {
        if (!listenForExternalNetworkSignals) {
          return;
        }

        if (externalSurfaceId && event.targetId !== externalSurfaceId) {
          return;
        }

        void queryClient.invalidateQueries({
          queryKey: ['endpoint-signals-paginated', event.targetId],
          exact: false,
        });
        void queryClient.invalidateQueries({
          queryKey: ['signal-counts', event.targetId],
          exact: false,
        });
        return;
      }

      if (!applicationId || event.targetId !== applicationId) {
        return;
      }

      void queryClient.invalidateQueries({
        queryKey: ['endpoint-signals-paginated', applicationId],
        exact: false,
      });
      void queryClient.invalidateQueries({
        queryKey: ['signal-counts', applicationId],
        exact: false,
      });
    });

    return unsubscribe;
  }, [
    applicationId,
    externalSurfaceId,
    listenForExternalNetworkSignals,
    subscribe,
    queryClient,
  ]);
};
